import React, { ReactNode } from 'react';

import classNames from 'classnames';

import classes from './UserInfoCell.module.scss';

type UserInfoCellProps = (
  | { name?: undefined; firstName: string; lastName: string }
  | {
      name: string;
      firstName?: undefined;
      lastName?: undefined;
    }
) & {
  email?: string;
  phone?: string;
  extraInfo?: string;
  dataTestId?: string;
  href: string;
  disabled?: boolean;
  nameAdornment?: ReactNode;
};

/* disabled: true => aria-disabled navigation prevented via CSS pointer-events: none */
const UserInfoCell = ({
  firstName,
  lastName,
  name,
  email,
  phone,
  extraInfo,
  dataTestId,
  href,
  disabled,
  nameAdornment,
}: UserInfoCellProps) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.nameRow}>
        <a
          href={href}
          className={classes.link}
          aria-disabled={disabled}
          data-test-id={dataTestId}
        >
          <h6 className={classNames(classes.name, 'private-info')}>
            {name ? (
              <span>{name}</span>
            ) : (
              <>
                <span>{firstName}</span>
                &nbsp;
                <span>{lastName}</span>
              </>
            )}
          </h6>
        </a>
        {nameAdornment}
      </div>
      {(email || phone || extraInfo) && (
        <a
          href={href}
          className={classNames(classes.contactInfo, classes.link)}
          aria-disabled={disabled}
        >
          {email && <p className="private-info">{email}</p>}
          {phone && <p className="private-info">{phone}</p>}
          {extraInfo && <p className="private-info">{extraInfo}</p>}
        </a>
      )}
    </div>
  );
};

export { UserInfoCell };
